import { render, staticRenderFns } from "./workWithTubberJob.vue?vue&type=template&id=27007d4c&scoped=true"
import script from "./workWithTubberJob.vue?vue&type=script&lang=js"
export * from "./workWithTubberJob.vue?vue&type=script&lang=js"
import style0 from "./workWithTubberJob.vue?vue&type=style&index=0&id=27007d4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27007d4c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,VBreadcrumbs: require('/var/www/tubber-new/components/global/v/breadcrumbs.vue').default,VButton: require('/var/www/tubber-new/components/global/v/button.vue').default})
